<template>
    <div class="top">
        <div class="container-fluid">
            <div class="order-detail">
                <h2 class="brand">
                    {{brandName}}-{{storeName}}
                </h2>
                <div class="detail order-no">訂單編號：{{orderSn}}</div>
                <div class="detail">
                    {{storeCity}}{{storeTownship}}{{storeAddress}}
                    <br>
                    訂單建立時間：{{orderWorkedAt}}
                    <br>
                    完成結帳時間：{{orderCreatedAt}}
                    <span class="location" v-if="false"><img src="@/assets/images/location_blue.svg">3.3 km</span>
                </div>
            </div>
        </div>
        <div class="arrival-time">

            <div class="text text-center"
                 :class="{'dark':takeoutStatus === 0 || takeoutStatus === 5 ,
                 'blue':takeoutStatus === 1 ,
                 'yellow':takeoutStatus === 2 || takeoutStatus === 3,
                 'red':takeoutStatus === 4 ,}">
                {{takeoutStatusString}}
            </div>

            <div class="d-flex dash">
                <div :class="takeoutStatus >= 0 && takeoutStatus !== 4 ? 'get' : ''"/>
                <div :class="takeoutStatus >= 1 && takeoutStatus !== 4 ? 'get' : ''"/>
                <div :class="takeoutStatus >= 2 && takeoutStatus !== 4 ? 'get' : ''"/>
                <div :class="takeoutStatus === 5 ? 'get' : ''"/>
            </div>

            <div class="d-flex">
                <div class="dark mr-2">{{orderType === 0 ? "預計取餐時間" : "預計送餐時間"}}</div>
                <div class="dark mr-2">{{estimatedTimeString}}</div>
                <div class="time red flex-grow-1">{{timeString}}</div>
            </div>

        </div>
    </div>
</template>

<script>

export default {
    name: "DeliveryInfo",
    props: ['id', 'orderId'],
    data() {
        return {
            orderSn: '',
            storeName: '',
            storeCity: '',
            storeTownship: '',
            storeAddress: '',
            brandName: '',
            orderType: 0,
            takeoutStatus: 0,
            takeoutStatusString: '',
            userGetTime: '',
            estimatedTimeString: '',
            timeString: '',
            orderCreatedAt: '',
            orderWorkedAt: '',
        }
    },
    created() {
        this.setupData()
    },
    mounted() {

    },
    methods: {
        setupData() {
            this.$http.fetchWithAuth`GetTakeoutDeliveryInfo${{
                'id': this.id,
                'orderId': this.orderId,
            }}
              ${json => {

                if (json.status) {
                    let takeoutOrder = json.data.takeoutOrder

                    this.orderSn = takeoutOrder.orderSn
                    this.storeName = takeoutOrder.storeName
                    this.storeCity = takeoutOrder.storeCity
                    this.storeTownship = takeoutOrder.storeTownship
                    this.storeAddress = takeoutOrder.storeAddress
                    this.brandName = takeoutOrder.brandName
                    this.orderType = takeoutOrder.orderType
                    this.takeoutStatus = takeoutOrder.takeoutStatus
                    this.takeoutStatusString = takeoutOrder.takeoutStatusString
                    this.userGetTime = takeoutOrder.userGetTime
                    this.estimatedTimeString = takeoutOrder.estimatedTimeString
                    this.timeString = takeoutOrder.timeString
                    this.orderWorkedAt = takeoutOrder.orderWorkedAt
                    this.orderCreatedAt = takeoutOrder.orderCreatedAt
                    this.$emit('deliveryInfoResult', 'renewBanner', takeoutOrder.imgUrl);
                } else {
                    this.$public.showNotify(json.message, json.status);
                }
            }}`;
        },
    }
}
</script>

